module.exports = __webpack_public_path__ + "img/credible-layer1.f8e61650.svg";